import { GetBreedsResponse } from 'types/wagapi';

import {
  WAG_API_URL,
  WagApiEndpoint,
} from '../../constants/endpoints';
import { useApiQuery } from '../../wag-react/common/api';

export const useGetBreeds = () => {
  const {
    data,
    query,
  } = useApiQuery<GetBreedsResponse>(WagApiEndpoint.GetBreeds, {
    baseURL: WAG_API_URL,
  });

  return {
    data,
    query,
  };
};
